import React from "react";
import ReactDOM from "react-dom";
import { Timeline } from './Timeline'
import { Typography } from "@mui/material";

export default function Root(props) {

  return <div style={{
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  }}>
     <Timeline {...props} />
    </div>;
}
